import React from "react";
import { View, Text, ActivityIndicator, StyleSheet } from "react-native";

import { SynapseDarkTheme } from "../theme/SynapseTheme";

/** One loading message for every loader in the app. */
export const LOADING_MESSAGE = "Warming today's puzzles…";

const { colors, customColors } = SynapseDarkTheme;

/** Full-bleed boot/warm overlay. Covers the game board while the app warms;
 *  the AppHeader (logo) remains visible above it for branding. */
const LoadingOverlay: React.FC = () => (
  <View style={styles.overlay} testID="loading-overlay">
    <ActivityIndicator size="large" color={customColors.currentNode} />
    <Text style={styles.text}>{LOADING_MESSAGE}</Text>
  </View>
);

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: colors.background,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  text: { color: colors.onSurface, marginTop: 16, fontSize: 16 },
});

export default LoadingOverlay;
